export default {
  configurations(state) {
    return state.configurations;
  },
  configurator(state) {
    return state.configurator;
  },
  has_preloaded(state) {
    return state.app_preloaded;
  },
  has_configurator(state) {
    return state.is_configurator_fetched;
  },
  has_overlay(state) {
    return state.configurator_overlay;
  },
  social(state) {
    return state.social;
  },
  active_set(state) {
    if (!state.is_configurator_undefined && state.is_configurator_selected)
      return state.configurator.configs.find(item => item.active);
  },
  combination(state) {
    if (state.is_configurator_undefined || !state.is_configurator_selected)
      return false;
    const non_overlay_configs = state.configurator.configs.filter(
      item => !item.isOverlay
    );
    return non_overlay_configs.reduce((acc, current) => {
      const active_material = current.material.find(mat => mat.active);
      return acc + (current.id + active_material.material_id);
    }, '');
  },
  excluded_overlays(state) {
    if (state.is_configurator_undefined || !state.is_configurator_selected)
      return false;

    let overlays = [];

    const non_overlay_configs = state.configurator.configs.filter(
      item => !item.isOverlay
    );

    const materials = non_overlay_configs.map(item => {
      return item.material.find(mat => mat.active);
    });

    materials.forEach(mat => {
      if (mat.excluded_overlays && mat.excluded_overlays !== null) {
        mat.excluded_overlays.map(ex => {
          if (!overlays.includes(ex)) overlays.push(ex);
        });
      }
    });
    return overlays;
  },
  type(state) {
    return state.type;
  },
  active_materials(state) {
    if (state.is_configurator_undefined || !state.is_configurator_selected)
      return false;
    const overlays = state.configurator.configs.filter(conf => conf.isOverlay);
    let overlay_arr = [];
    let config_id;
    let overlay_paths = overlays.map(conf => {
      let items = conf.material.filter(mat => mat.active && mat.isDisabled);
      const id = conf.id;
      const material = conf.material.find(mat => mat.active);
      const material_id = material.material_id;
      config_id = conf.id;
      if (items.length !== 0) {
        items.map(acc => {
          if (acc !== undefined) {
            overlay_arr.push(acc);
          }
        });
      }
      return `./Configurations/${state.configurator.name}/overlays/${id +
        material_id}.png`;
    });
    overlay_arr.map(mat => {
      overlay_paths.push(
        `./Configurations/${state.configurator.name}/overlays/${config_id +
          mat.material_id}.png`
      );
    });
    return overlay_paths.sort((a, b) => {
      const first = a.replace(/[^\d]/g, '');
      const second = b.replace(/[^\d]/g, '');
      return parseInt(first) - parseInt(second);
    });
  },
  price(state) {
    if (state.is_configurator_undefined || !state.is_configurator_selected)
      return false;
    return state.configurator.configs.reduce((acc, current) => {
      let active_material_price;
      let accessories_price = [];
      const active_material = current.material.find(mat => mat.active);
      const accessory_material = current.material.filter(
        mat => mat.active && mat.isDisabled
      );

      if (!active_material.isDisabled) {
        active_material_price = active_material.price;
      }

      accessory_material.map(mat => {
        accessories_price.push(mat.price);
      });

      accessories_price = accessories_price.reduce(
        (partial_sum, a) => parseInt(partial_sum || 0) + parseInt(a || 0),
        0
      );

      if (typeof active_material != 'undefined') {
        return acc + parseInt(active_material_price || 0) + accessories_price;
      } else {
        return acc;
      }
    }, 0);
  },
  selected_materials(state) {
    if (state.is_configurator_undefined || !state.is_configurator_selected)
      return false;
    return state.configurator.configs.map(config => {
      return {
        name: config.name,
        material: [config.material.find(item => item.active)],
      };
    });
  },
};
